<template>
    <div class="builder-wrapper" :class="{'menu-open': menuOpen}">
        <div class="menu">
            <span class="menu-link" @click="menuOpen=!menuOpen"><i class="fas" :class="{'fa-bars': !menuOpen, 'fa-times': menuOpen}"></i></span>
            <router-link :to="{name: 'Welcome'}"><img class="logo" src="../../../assets/logo.png"/></router-link>

            <div class="menu-options">
                <router-link :to="{name: 'Welcome'}"><i class="fas fa-home" style="margin: 0;"></i></router-link>
                <router-link :to="{name: 'Store'}"><i class="fas fa-shopping-cart"></i> Kit Store</router-link>
                <router-link :to="{name: 'Builder'}" class="active"><i class="fas fa-toolbox"></i> Kit Builder</router-link>
                <router-link :to="{name: 'Director'}"><i class="fas fa-bullhorn"></i> Escape It Director</router-link>
                <!--<a><i class="fas fa-user"></i></a>-->
                <a @click="logout()"><i class="fas fa-power-off"></i></a>
            </div>
        </div>

        <div class="builder-frame" :class="kitBackground">
            <div class="side-menu">
                <div class="main">
                    <router-link :to="{name: 'Builder'}" class="active"><i class="fas fa-toolbox"></i> Builder</router-link>
                    <router-link :to="{name: 'Director'}"><i class="fas fa-bullhorn"></i>Director</router-link>
                    <!--<a><i class="fas fa-user"></i></a>-->
                    <a @click="logout()"><i class="fas fa-power-off"></i></a>
                </div>
                <div class="builds" v-if="mode==='builds'">
                    <header>
                        <h2><i class="far fa-toolbox"></i> Your Kit Builds</h2>
                        <b-button variant="primary" class="new" @click="newBuildForm = !newBuildForm"><i class="fas fa-plus-square"></i></b-button>
                        <div class="clearfix"></div>
                    </header>
                    <ul class="build-list">
                        <li class="build" v-for="build in builds" :key="build.id" @click="selectBuild(build)" :class="{'active': build === selectedBuild}">
                            <div class="title">{{build.title}}</div>
                            <div class="date">Created on {{build.date_created | date('MMM Do YYYY, h:mm a')}}</div>
                        </li>
                    </ul>

                    <div v-if="newBuildForm" class="new-build-form">
                        <div v-if="kits.length > 0">
                            <h5><i class="fas fa-plus-square"></i> New Kit Build</h5>
                            <b-form>
                                <b-select v-model="newBuild.kit">
                                    <template slot="first">
                                        <option :value="null" disabled>Select a Kit</option>
                                        <option value="1" v-if="kits.indexOf(1) !== -1">Self Destruct</option>
                                    </template>
                                </b-select>
                                <!--<b-form-input id="title" v-model="newBuild.title" required placeholder="Kit Build Title"></b-form-input>-->

                                <div class="buttons">
                                    <b-button variant="primary" @click="createBuild()">Create</b-button>
                                    <b-button variant="link" @click="newBuildForm=false">Cancel</b-button>
                                </div>
                            </b-form>
                        </div>
                        <div v-else>
                            <h5><i class="fas fa-plus-square"></i> New Kit Build</h5>

                            <h5>You don't own any Escape Room Kits yet! Check out the store!</h5>
                            <b-button variant="inverse" @click="setMode('store')"><i class="fas fa-shopping-cart"></i> &nbsp;Escape Room Kit Store</b-button>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="mode==='builds'">
                <div v-if="view==='empty'" class="content-frame empty">
                    <div class="full">
                        <img src="../../../assets/build_instructions_full_1.png" class="instructions-1"/>
                    </div>
                    <div class="collapsed">
                        <img src="../../../assets/build_instructions_collaped_1.png" class="instructions-1"/>
                    </div>
                </div>
                <div v-if="view==='buildHelp'">
                    <help :build="build"></help>
                </div>

                <div v-if="selectedBuild">
                    <div class="content-frame builds">
                        <div v-if="view==='download'" class="info">

                            <h2>{{build.title}}</h2>

                            <ul class="meta">
                                <li>
                                    <strong>Escape Room:</strong>
                                    <span v-if="build.kit_id===1">Self Destruct</span>
                                </li>
                                <li><strong>Created:</strong> {{build.date_created | date('MMM Do YYYY, h:mm a')}}</li>
                                <li>
                                    <b-button variant="link" size="sm" @click="deleteBuild(build.id)" class="delete-button"><i class="fas fa-trash-alt"></i> Delete Build</b-button>
                                </li>
                            </ul>

                            <h3>Getting Started</h3>
                            <ol>
                                <li>
                                    <div class="task">Construct Do-It-Yourself Props</div>
                                    <div class="instructions"></div>
                                    <div class="buttons">
                                        <b-button variant="primary" size="sm"><i class="fas fa-print"></i> Print Materials</b-button>
                                        <b-button variant="primary" size="sm"><i class="fas fa-cut"></i> View Instructions</b-button>
                                        <b-button variant="inverse" size="sm"><i class="fas fa-print"></i> Print Instructions</b-button>
                                    </div>
                                </li>
                                <li>
                                    <div class="task">Customize Puzzles and Riddles</div>
                                    <div class="instructions"></div>
                                    <div class="buttons">
                                        <b-button variant="primary" size="sm"><i class="fas fa-wrench"></i> Customize Build</b-button>
                                        <b-button variant="inverse" size="sm"><i class="fas fa-print"></i> Print Instructions</b-button>
                                    </div>
                                </li>
                                <li>
                                    <div class="task">Download & Print Puzzles</div>
                                    <div class="instructions"></div>
                                    <div class="buttons">
                                        <b-button class="download" variant="primary" size="lg" :href="API_URL + 'kits/download/' + build.id + '?auth=' + AUTH" target="_blank"><i class="fas fa-print"></i> Download & Print Puzzles</b-button>
                                    </div>
                                </li>
                            </ol>

                            <h3>Extra Printables</h3>
                            <ul>
                                <li>Setup Instructions</li>
                                <li>Escape Plan Diagram</li>
                                <li>Co-existence Lounge Sign</li>
                                <li>Junk: Electronic Schematics</li>
                                <li>Junk: Ship Diagram/Map</li>
                            </ul>

                        </div>
                        <div v-else-if="view==='customize'">
                            <component v-if="buildComponent" :is="buildComponent" :build="build"></component>
                        </div>
                        <div v-else-if="view==='props'">
                            <component v-if="propsComponent" :is="propsComponent" :build="build"></component>
                        </div>
                        <div v-else-if="view==='help'">
                            <component v-if="helpComponent" :is="helpComponent" :build="build"></component>
                        </div>
                    </div>

                    <div class="control" v-if="selectedBuild && build">
                        <div class="menu-options">
                            <ul>
                                <li @click="setView('download')" :class="{'active': view==='download'}"><i class="fas fa-arrow-circle-down"></i> Download</li>
                                <li @click="setView('customize')" :class="{'active': view==='customize'}"><i class="fas fa-wrench"></i> Customize</li>
                                <li @click="setView('props')" :class="{'active': view==='props'}"><i class="far fa-cut"></i> Props</li>
                                <li @click="setView('help')" :class="{'active': view==='help'}"><i class="fas fa-question-square"></i> Help</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import auth from '../../../services/auth';
    import kits from "../../../services/kits";
    import coupons from "../../../services/coupons";
    import router from "../../../router";
    import Help from './help.vue';

    import Kit1Builder from "../../../kits/1/builder.vue";
    import Kit1Props from "../../../kits/1/props.vue";
    import Kit1Help from "../../../kits/1/help_builder.vue";

    let API_URL = 'https://api.escapeitkit.com:443/api/';
    if (location.hostname === 'localhost') {
        API_URL = 'http://localhost:9000/api/';
    }

    export default {
        name: "builder",
        components: {
            Help, Kit1Builder, Kit1Props, Kit1Help
        },
        mounted() {
            this.$store.commit('setNavbarVisibility', false);
        },
        destroyed() {
            this.$store.commit('setNavbarVisibility', true);
        },
        data: function () {
            return {
                menuOpen: false,
                newBuildForm: false,
                newBuild: {
                    title: '',
                    kit: null
                },
                showMenu: false,
                mode: 'builds',
                view: 'empty', // Empty state
                kitBackground: 'none',
                selectedBuild: null,
                buildComponent: null,
                propsComponent: null,
                helpComponent: null,
                build: null,

                selectedKit: null,
                price: '$39.99',
                coupon: null,
                appliedCoupon: null,
                chargeAmount: 3999,

                API_URL: API_URL,
                AUTH: auth.getAuthHeader().Authorization.replace('Bearer ','')
            }
        },
        methods: {
            createBuild: function () {
                if (this.newBuild.kit) {
                    if (this.newBuild.title === '') {
                        if (this.newBuild.kit === "1") this.newBuild.title = 'Self Destruct';
                        if (this.newBuild.kit === "2") this.newBuild.title = 'The Mansion Heist';
                    }
                    kits.buildKit(this.newBuild.kit, this.newBuild.title).then(build => {
                        this.newBuild = {
                            title: '',
                            kit: null
                        };
                        this.newBuildForm = false;
                        this.selectBuild(build);
                    });
                } else {
                    window.alert('Please choose a kit.');
                }
            },
            buildKitNow: function () {
                this.setMode('builds');
                this.newBuildForm = true;
            },
            setMode: function (mode) {
                this.kitBackground = 'none';
                this.buildComponent = null;
                this.propsComponent = null;
                this.helpComponent = null;
                this.build = null;
                this.selectedBuild = null;
                this.selectedKit = null;
                this.newBuildForm = false;

                if (mode === 'builds') this.view = 'empty';

                this.mode = mode;
            },
            setView: function (view) {
                this.view = view;
            },
            selectBuild: function (build) {
                this.selectedBuild = build;

                kits.getBuild(build.id).then(build => {
                    this.build = build;
                    this.buildComponent = 'kit' + build.kit_id + '-builder';
                    this.propsComponent = 'kit' + build.kit_id + '-props';
                    this.helpComponent = 'kit' + build.kit_id + '-help';
                    this.kitBackground = 'kit' + build.kit_id;
                    this.view = 'download';
                }, err => {
                    console.log(err);
                    window.alert('An error occurred.');
                    router.push({name: 'Builder'});
                });
            },
            deleteBuild: function(build_id) {
                if (confirm('Are you sure you want to delete this build? This is a permanent action.')) {
                    kits.deleteBuild(build_id).then(response => {
                        this.kitBackground = 'none';
                        this.buildComponent = null;
                        this.propsComponent = null;
                        this.helpComponent = null;
                        this.build = null;
                        this.selectedBuild = null;
                    })
                }
            },
            selectKit: function(kit_id) {
                this.selectedKit = kit_id;
            },
            applyCoupon() {
                if (this.coupon) {
                    coupons.checkCouponCode(this.coupon, this.selectedKit).then(result => {
                        this.appliedCoupon = result;
                        this.coupon = result.coupon;
                        this.price = '$' + result.price;
                        this.chargeAmount = (parseFloat(result.price)*100);
                        console.log(result, this.chargeAmount);
                    }, err => {
                        window.alert('That\'s not a valid coupon code.');
                    });
                }
            },
            removeCoupon() {
                this.appliedCoupon = null;
                this.price = '$39.99';
                this.chargeAmount = 3999;
                this.coupon = null;
            },
            purchaseKit(kit) {
                if (this.chargeAmount === 0) {
                    // Free?
                    kits.purchaseKit(this.selectedKit, '', (this.appliedCoupon) ? this.appliedCoupon.coupon : null).then(() => {
                        this.selectedKit = null;
                        this.appliedCoupon = null;
                        this.price = '$39.99';
                        this.chargeAmount = 3999;
                        this.coupon = null;

                        // TODO
                        this.kits.push(1);
                    }, err => {
                        console.log(err);
                        window.alert('An error occurred.');
                    });
                } else {
                    this.$checkout.open({
                        name: kit,
                        currency: 'USD',
                        amount: this.chargeAmount,
                        panelLabel: 'Purchase Kit - {{amount}}',

                        token: (token) => {
                            kits.purchaseKit(this.selectedKit, token, (this.appliedCoupon) ? this.appliedCoupon.coupon : null).then(() => {
                                this.selectedKit = null;
                                this.appliedCoupon = null;
                                this.price = '$39.99';
                                this.chargeAmount = 3999;
                                this.coupon = null;

                                // TODO
                                this.kits.push(1);
                            }, err => {
                                console.log(err);
                                window.alert('An error occurred.');
                            });
                        }
                    });
                }
            },
            logout() {
                auth.logout();
            }
        },
        computed: {
            options: function () {
                let options = [];
                let builds = this.$store.getters['user/builds'];
                for (let i = 0; i < builds.length; i++) {
                    let build = builds[i];
                    options.push({value: build, text: build.title});
                }
                return options;
            },
            kits: function () {
                return this.$store.getters['user/kits'];
            },
            builds: function () {
                return this.$store.getters['user/builds'];
            },
            user: function() {
                return this.$store.getters['user/user'];
            }
        },
        filters: {
            capitalize: function (value) {
                if (!value) return '';
                value = value.toString();
                return value.charAt(0).toUpperCase() + value.slice(1);
            }
        }
    }

</script>

<style lang="scss" scoped>
    .builder-wrapper {
        font-family: "Roboto", sans-serif;

        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;

        .menu {
            margin: 0 auto;

            .logo {
                padding: 12px 0 0 10px;
                float: left;

                img {
                    max-width: 179px;
                    width: 100%;
                }

                @media (max-width: 770px) {
                    float: right;
                    margin-right: 16px;
                }
            }

            .menu-link {
                float: left;
                padding: 20px 0 0 20px;
                display: none;

                i {
                    font-size: 26px;
                }

                @media (max-width: 770px) {
                    display: inline-block;
                }
            }

            .menu-options {
                position: absolute;
                right: 0;

                a {
                    display: inline-block;
                    padding: 20px;
                    font-size: 18px;
                    color: rgba(255, 255, 255, 0.50);
                    height: 65px;

                    i {
                        font-size: 22px;
                        margin-right: 10px;
                        color: rgba(255, 255, 255, 0.50);
                    }

                    &:hover {
                        background-color: rgba(0, 0, 0, 0.30);
                        text-decoration: none;
                    }

                    &.active {
                        box-shadow: inset 0 3px 0 #e45114;
                        background-color: rgba(16, 16, 16, 0.98);
                        color: white;
                        i {
                            color: white;
                        }

                    }
                }

                @media (max-width: 770px) {
                    display: none;
                }
            }
        }

        .builder-frame {
            margin: 0 auto;
            position: absolute;
            left: 0;
            right: 0;
            top: 65px;
            bottom: 0;

            background-color: rgba(0, 0, 0, 0.7);

            &.kit1 {
                background: #111 url('../../../assets/kit_1.jpg');
                background-size: cover;
            }

            .side-menu {
                position: absolute;
                width: 300px;
                bottom: 0;
                left: 0;
                top: 0;

                background-color: rgba(0, 0, 0, 0.9);

                .main {
                    display: none;
                    background-color: rgba(255, 255, 255, 0.1);

                    a {
                        display: inline-block;
                        padding: 10px 20px 8px 20px;
                        font-size: 14px;
                        color: rgba(255, 255, 255, 0.50);

                        i {
                            font-size: 15px;
                            margin-right: 5px;
                            color: rgba(255, 255, 255, 0.50);
                        }

                        &:hover {
                            background-color: rgba(0, 0, 0, 0.30);
                            text-decoration: none;
                        }

                        &.active {
                            box-shadow: inset 0 3px 0 #e45114;
                            background-color: rgba(0, 0, 0, 0.7);
                            color: white;
                            i {
                                color: white;
                            }

                        }
                    }

                    @media (max-width: 768px) {
                        display: block;
                    }
                }

                header {
                    background-color: rgba(255, 255, 255, 0.3);
                    margin-bottom: 2px;
                    min-height: 38px;

                    h2 {
                        padding: 10px 20px 0;
                        margin: 0;
                        float: left;
                        font-size: 16px;

                        i {
                            margin-right: 6px;
                        }
                    }

                    .new {
                        float: right;
                        border-radius: 0;
                        border: none;
                        margin: 0;
                        font-size: 1.1rem;
                        border-left: 2px solid rgba(0, 0, 0, 0.6);
                    }
                }

                .menu-options {
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    left: 0;

                    ul {
                        list-style: none;
                        padding: 0;
                        margin: 0;
                        display: flex;
                        justify-content: space-between;

                        li {
                            flex-grow: 1;

                            text-align: center;
                            font-size: 0.7rem;
                            color: rgba(255, 255, 255, 0.50);
                            padding: 12px 5px 10px;
                            background-color: rgba(255, 255, 255, 0.15);
                            border-left: 1px solid rgba(0, 0, 0, 0.6);
                            border-right: 1px solid rgba(0, 0, 0, 0.6);
                            width: 25%;
                            position: relative;

                            i {
                                display: block;
                                font-size: 20px;
                                margin-bottom: 6px;
                                color: white;
                            }

                            span.badge {
                                position: absolute;
                                top: 0;
                                right: 0;
                                border-radius: 0;
                                padding: 3px 5px;
                                background-color: rgb(1, 122, 255);
                                font-size: 10px;
                                font-weight: bold;

                                &.none {
                                    background-color: transparent;
                                    padding: 3px 4px 0 5px;

                                    i {
                                        color: red;
                                        font-size: 11px;
                                    }
                                }
                            }

                            &:first-child {
                                border-left: 0;
                            }

                            &:last-child {
                                border-right: 2px solid rgba(0, 0, 0, 0.6);
                            }

                            &:hover {
                                background-color: rgba(255, 255, 255, 0.20);
                            }

                            &.active {
                                box-shadow: inset 0 -3px 0 #e45114;
                                color: white;
                                background-color: transparent;

                            }
                        }
                    }
                }

                .builds {
                    .build-list {
                        list-style: none;
                        margin: 0;
                        padding: 0;

                        .build {
                            padding: 16px;
                            border-bottom: 2px solid #000;
                            cursor: pointer;
                            background-color: rgba(255, 255, 255, 0.15);
                            border-left: 3px solid transparent;

                            .title {
                                font-size: 18px;
                            }
                            .date {
                                font-size: 11px;
                                color: #bbbbbb;
                            }

                            &:hover {
                                background-color: rgba(255, 255, 255, 0.12);
                            }

                            &.active {
                                border-left: 3px solid #e45114;
                                background-color: rgba(255, 255, 255, 0.08);
                            }
                        }
                    }

                    .new-build-form {
                        position: absolute;
                        top: 38px;
                        left: 0;
                        right: 0;

                        padding: 16px;
                        background-color: #017AFF;

                        h5 {
                            font-size: 16px;
                            margin-bottom: 20px;

                            i {
                                margin-right: 8px;
                            }
                        }

                        input, select {
                            margin-bottom: 10px;
                        }

                        .buttons {
                            margin-top: 20px;
                            .btn-primary {
                                background: white;
                                color: black;
                            }
                            .btn-link {
                                color: white;
                            }
                        }

                        @media (max-width: 768px) {
                            top: 77px;
                        }
                    }
                }

                .store {
                    .store-kit-list {
                        list-style: none;
                        margin: 0;
                        padding: 0;

                        .kit {
                            padding: 16px;
                            cursor: pointer;
                            border-left: 3px solid transparent;

                            .title {
                                font-size: 18px;
                            }
                            .teaser {
                                font-size: 11px;
                                color: #bbbbbb;
                            }
                            .own {
                                font-size: 13px;
                                font-style: italic;
                                margin-top: 12px;
                                i {
                                    color: green;
                                    margin-right: 4px;
                                }
                            }
                            .price {
                                margin-top: 12px;
                                font-size: 13px;

                                .retail {
                                    text-decoration: line-through;
                                    color: rgba(255, 255, 255, 0.7);
                                    font-size: 0.85rem;
                                    margin-right: 4px;
                                }

                                .sale {
                                    padding: 2px 7px;
                                    margin-left: 15px;
                                    background-color: rgb(234, 104, 31);
                                }

                                i {
                                    color: green;
                                    margin-right: 6px;
                                }

                                &.coming-soon {
                                    i {
                                        color: rgb(234, 104, 31);
                                    }
                                }

                            }

                            &.kit1 {
                                background: #111 url('../../../assets/kit_1_header_faded.jpg');
                                background-size: cover;
                            }
                            &.kit2 {
                                background: #111 url('../../../assets/kit_2_header_faded.jpg');
                                background-size: cover;
                            }

                            &:hover {
                                background-color: rgba(255, 255, 255, 0.12);
                            }

                            &.active {
                                border-left: 3px solid #e45114;
                                background-color: rgba(255, 255, 255, 0.08);
                            }
                        }
                    }
                }

                @media (max-width: 768px) {
                    display: none;
                }
            }

            .control {
                position: absolute;
                bottom: 0;
                left: 300px;
                right: 0;
                background-color: rgba(40, 40, 40, 0.9);

                min-height: 64px;

                @media (max-width: 768px) {
                    left: 0;
                }

                .control-info {
                    position: absolute;
                    left: 0;

                    .own {
                        margin: 15px 0 0 25px;

                        font-size: 18px;
                        font-style: italic;
                        i {
                            color: green;
                            margin-right: 4px;
                        }

                        .btn {
                            margin-left: 15px;

                            i {
                                color: white;
                            }
                        }
                    }

                    .buttons {
                        margin: 15px 0 0 25px;

                        i {
                            margin-right: 5px;
                        }
                    }
                }

                .menu-options {
                    position: absolute;
                    right: 0;
                    width: 280px;
                    height: 64px;

                    ul {
                        list-style: none;
                        padding: 0;
                        margin: 0;
                        display: flex;
                        justify-content: space-between;

                        li {
                            flex-grow: 1;

                            text-align: center;
                            font-size: 0.7rem;
                            color: rgba(255, 255, 255, 0.50);
                            padding: 12px 5px 10px;
                            /*background-color: rgba(255, 255, 255, 0.15);*/
                            border-left: 1px solid rgba(0, 0, 0, 0.6);
                            border-right: 1px solid rgba(0, 0, 0, 0.6);
                            width: 25%;
                            position: relative;

                            i {
                                display: block;
                                font-size: 20px;
                                margin-bottom: 6px;
                                color: white;
                            }

                            &:first-child {
                                border-left: 2px solid rgba(0, 0, 0, 0.6);
                            }

                            &:last-child {
                                border-right: 0;
                            }

                            &:hover {
                                background-color: rgba(255, 255, 255, 0.20);
                            }

                            &.active {
                                box-shadow: inset 0 -3px 0 #e45114;
                                color: white;
                                background-color: rgba(0, 0, 0, 0.7);

                            }
                        }
                    }
                }

                .applied-coupon {
                    margin-left: 15px;

                    button {
                        margin-left: 15px;
                    }
                }
                .cost-box {
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    color: white;
                    background: #ea681f;
                    padding: 15px 35px 15px 20px;
                    border-left: 4px solid white;
                    border-top: 4px solid white;
                    border-top-left-radius: 30px;
                    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
                    font-weight: normal;
                    cursor: pointer;

                    i {
                        margin-right: 10px;
                        font-size: 26px;
                        vertical-align: text-bottom;
                    }

                    .retail {
                        text-decoration: line-through;
                        color: rgba(255, 255, 255, 0.7);
                        font-size: 0.85rem;
                        margin-right: 4px;
                    }

                    .sale {
                        position: absolute;
                        top: 0;
                        right: 20px;
                        margin-top: -18px;
                        background: white;
                        padding: 3px 12px;
                        font-weight: bold;
                        color: black;
                        border-radius: 20px;
                        font-size: 14px;
                    }
                }

                input {
                    margin-left: 15px;
                    background-color: black;
                    border: 1px solid #333;
                    border-radius: 5px;
                    padding: 8px 10px;
                    color: white;
                }

                @media (max-width: 500px) {
                    .control-info {
                        position: static;
                        display: block;
                        left: auto;

                        padding: 5px 15px 5px 15px;
                        background-color: rgba(0, 0, 0, 0.7);

                        /*.icon {*/
                            /*padding: 10px 0 0;*/
                            /*float: right;*/
                            /*i {*/
                                /*font-size: 30px;*/
                            /*}*/
                        /*}*/

                        /*.room-name {*/
                            /*padding: 0;*/
                        /*}*/
                    }

                    .menu-options {
                        position: static;
                        display: block;
                        width: 100%;
                    }
                }
            }

            .content-frame {
                position: absolute;
                bottom: 64px;
                left: 300px;
                top: 0;
                right: 0;
                padding: 10px 10px 5rem 10px;

                overflow: auto;

                background-color: rgba(0, 0, 0, 0.8);

                @media (max-width: 768px) {
                    left: 0;
                }

                &.empty {
                    background: #111 url('../../../assets/dark_cartographer_bg.png');
                    bottom: 0;

                    .full {
                        .instructions-1 {
                            position: absolute;
                            top: 0;
                            left: 0;
                        }
                        .instructions-2 {
                            position: absolute;
                            top: 0;
                            right: 0;
                        }
                        .instructions-3 {
                            position: absolute;
                            bottom: 0;
                            left: 0;
                        }

                        @media (max-width: 768px) {
                            display: none;
                        }
                    }

                    .collapsed {
                        display: none;

                        .instructions-1 {
                            position: absolute;
                            top: 0;
                            left: 0;
                        }

                        @media (max-width: 768px) {
                            display: block !important;
                        }
                    }

                }

                &.builds {
                    .info {
                        font-family: "Roboto", sans-serif;
                        line-height: 1.9rem;
                        padding: 25px 40px 0 40px !important;
                        font-size: 0.9rem;

                        ul.meta {
                            padding: 0;
                            list-style: none;

                            li {
                                display: inline-block;
                                font-size: 13px;
                                color: #aaa;
                                padding-right: 15px;

                                strong {
                                    color: #d9d9d9;
                                }
                            }
                        }

                        .delete-button {
                            font-weight: normal;
                            color: #666 !important;
                            text-decoration: none;
                            font-size: 13px;

                            &:hover, &:active {
                                color: #E45114 !important;
                            }
                        }

                        h2 {
                            font-family: 'Sumana', serif;
                            padding-bottom: 0;
                        }

                        h3 {
                            font-family: 'Sumana', serif;

                            font-size: 1.5rem;
                            border-bottom: 1px solid #E46A3B;
                            padding-bottom: 8px;
                            margin-bottom: 1.4rem;

                            i {
                                width: 30px;
                                margin-right: 0.5rem;
                            }
                        }

                        i {
                            margin: 0 6px;
                        }

                        ol li, ul li {
                            margin-bottom: 15px;
                            line-height: normal;
                        }

                        ol {
                            font-size: 16px;

                            li {
                                padding-left: 10px;
                                margin-bottom: 25px;
                            }

                            .task {
                                margin-bottom: 15px;
                            }

                            .btn {
                                padding-right: 15px;
                                margin-bottom: 10px;
                            }
                        }

                    }
                }

                &.store {
                    padding: 0;

                    .kit-meta {
                        list-style: none;
                        padding: 0;
                        margin-bottom: 0;

                        i {
                            color: #ea681f;
                            margin-right: 10px;
                            font-size: 18px;
                            width: 25px;
                        }

                        li {
                            margin-bottom: 5px;
                            font-size: 14px;
                        }
                    }

                    .kit-header {
                        position: relative;

                        header {
                            padding: 35px;
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            right: 0;

                            h4 {
                                font-size: 2rem;
                                margin-bottom: 0.5rem;
                                font-family: 'Sumana', serif;
                                color: white;
                                text-transform: none;

                                i {
                                    font-size: 3rem;
                                    margin-right: 10px;
                                }
                            }
                        }

                        img {
                            width: 100%;
                        }
                    }

                    .container {
                        margin: 0 0 3rem;
                        padding: 0;
                    }

                    .card {
                        background-color: rgb(27, 27, 27);
                        border-radius: 0;
                        padding: 20px;
                        font-size: 14px;

                        ul li {
                            font-size: 12px;
                        }
                    }
                }
            }

            @media (max-width: 500px) {
                .content-frame {
                    bottom: 123px;
                }
            }

        }

        &.menu-open {
            .builder-frame {
                .side-menu {
                    display: block;
                    z-index: 1000;
                    background: black;

                    -webkit-box-shadow: 5px 10px 50px 0 rgba(0,0,0,0.75);
                    -moz-box-shadow: 5px 10px 50px 0 rgba(0,0,0,0.75);
                    box-shadow: 5px 10px 50px 0 rgba(0,0,0,0.75);

                    transition: left 0.5s;

                    .menu-options ul li:last-child {
                        border-right: 0;
                    }
                }
                .content-frame {
                    /*display: none;*/
                    /*opacity: 0.4;*/
                }
                .control {
                    /*display: none;*/
                    /*opacity: 0.5;*/
                    /*background-color: rgba(0,0,0,0.9);*/

                    ul li {
                        display: none;
                    }

                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/app/builder/builder.vue